import { pick } from 'rambda'

const pickCategory = pick(['category'])
const pickArticle = pick(['category', 'introKeyFacts', 'topic'])
const pickArticleSpec = pick(['keyFacts', 'minimum', 'recommended', 'best'])

export default {
  auto: ['actions'],
  store: {
    actions: {
      CREATE_INTRO_COMPLETION({ dispatch }, { article, text, ...attributes }) {
        return dispatch('CREATE_COMPLETION', {
          type: 'INTRO',
          ...pickCategory(article),
          fields: {
            ...pickArticle(article),
            text,
          },
          ...attributes,
        })
      },
      CREATE_SPEC_COMPLETION({ dispatch }, { article, articleSpec, text, ...attributes }) {
        return dispatch('CREATE_COMPLETION', {
          type: 'SPEC',
          ...pickCategory(article),
          ...pick(['specTypeId'], articleSpec),
          fields: {
            ...articleSpec.fields,
            ...pickArticle(article),
            ...pickArticleSpec(articleSpec),
            text,
          },
          ...attributes,
        })
      },
    },
  },
}
